export default __webpack_public_path__ + "static/media/clock_red.cec336e9.svg";